import * as React from 'react';
import * as moment from 'moment';
import { safe, groupBy, isNullOrUndefined, isNullOrEmpty } from "../../utils";
import { IPageProperties } from "../../models";
import { Tooltip, Disclaimer } from '../../assets';
import { BackToTop } from "../../assets/BackToTop/BackToTop";
import { NumberFormat } from "../../assets";

const styles = require('./styles.pcss');
const backToTopstyles = require('./overrides/BackToTopoverride.pcss');

export class PageCharacteristics extends React.Component<IPageProperties, {}>{
    constructor(props) {
        super(props);

        this.getCharacteristic = this.getCharacteristic.bind(this);
    }

    getCharacteristic(groupedCharacteristics: any, type: string, isUK: boolean, title: string = null) {
        let { shareClass, appParams } = this.props;

        if (groupedCharacteristics[type]) {
            let showCharacteristicsText = title !== "Codes";
            if (type === "shareclass" || type === "risk") {
                groupedCharacteristics[type].sort((a, b) => {
                    let aName = a.label.toUpperCase();
                    let bName = b.label.toUpperCase();
                    if (aName < bName) {
                        return -1;
                    }
                    if (aName > bName) {
                        return 1;
                    }
                    return 0;
                });
            }
            let dateGroupedChars;
            if (type === "code") {
                dateGroupedChars = groupBy(groupedCharacteristics[type], (item) => item["characteristic_type"]);
            } else {
                dateGroupedChars = groupBy(groupedCharacteristics[type], (item) => item["date"]);
            }

            let disclaimers = [];
            return (
                <div>
                    <h2 className={styles.title + ' ' + styles.reasons}>{!isNullOrUndefined(title) ? title : type} {showCharacteristicsText ? "Characteristics" : ""}</h2>
                    {Object.keys(dateGroupedChars).map((key, index) => {
                        return (
                            <table key={index * 30}>
                                <thead>
                                    {(() => {
                                        if (type !== "code") {
                                            return (
                                                <tr>
                                                    <th></th>
                                                    <th>Content as at {moment(safe(() => dateGroupedChars[key][0]["date"], moment())).format("DD.MM.YYYY")}</th>
                                                </tr>

                                            );
                                        }
                                    })()}
                                </thead>
                                <tbody>
                                    {dateGroupedChars[key].map((item, idx) => {
                                        const isSector = item.key === 'comparative_sector_heading'; // is sector
                                        const isBenchmark = item.key === 'comparative_benchmark_heading'; // is benchmark (aka index)
                                        disclaimers.push(`characteristic_disclaimer_${item["key"]}_${appParams.clienttype}`);
                                        let tooltipItem = safe(() => shareClass.disclaimers[`characteristic_definition_${item["key"]}_${appParams.clienttype}`].shift(), null);
                                        return (
                                            <tr key={idx}>
                                                <td>{!isSector && !isBenchmark ? item["label"] : "Benchmark"}&nbsp;{!isNullOrUndefined(tooltipItem) && !tooltipItem.is_deleted ? <Tooltip text={tooltipItem.disclaimer} /> : ""}</td>
                                                <td>{item["characteristic_type"] === 'code' ? item["characteristic_value"] : 
                                                item["characteristic_type"] === 'shareclass' ? item["characteristic_value"] : <NumberFormat>{item["characteristic_value"]}</NumberFormat>}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        );
                    })}
                    <div className={styles.disclaimerSmall}>
                        {disclaimers.map((key, index) => <Disclaimer key={index} appParams={appParams} disclaimer={shareClass.disclaimers[key]} />)}
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    render() {
        let { shareClass, appParams } = this.props;
        let { region, clienttype } = appParams;
        let isUK = appParams.region.toLowerCase() === "uk";
        // Removed key facts check to filter the Comparative Sector(shareclass characteristic)
        let characteristics = safe(() => shareClass.statistics
            .filter(item => item.code === "characteristics")[0].values
            .filter(item => !item["key_fact"] && item["client_type"] === clienttype && (item["registration"] as string).toLowerCase() === region), []);
        let groupedCharacteristics = groupBy(characteristics, item => item["characteristic_type"] as string); 

        // Append Pound symbol to oeic_minimum_lump_sum_heading & oeic_minimum_additional_lump_sum_heading
        // https://kurtosys-prod-eng.atlassian.net/browse/MG-1461
        if (!isNullOrEmpty(groupedCharacteristics['shareclass'])) {
            const keysToAppendCurrencySymbolTo = ['oeic_minimum_lump_sum_heading', 'oeic_minimum_additional_lump_sum_heading'];
            groupedCharacteristics['shareclass'].forEach((characteristic: {}) => {
                if (keysToAppendCurrencySymbolTo.indexOf(characteristic['key']) > -1) {
                    characteristic['label'] = `${characteristic['label']} (£)`;
                }
            });
        }

        return (
            <div className={styles.wrapper}> {/*sets the max width to 960px for the component elements */}
                <div className={styles.pagecharacteristicsContainer}>
                    <BackToTop styles={backToTopstyles} />
                    <div className={styles.row}>
                        <div className={styles.colXs12 + ' ' + styles.colMd6}>
                            {this.getCharacteristic(groupedCharacteristics, "fund", isUK)}
                            {this.getCharacteristic(groupedCharacteristics, "risk", isUK)}
                        </div>
                        <div className={styles.colXs12 + ' ' + styles.colMd6}>
                            {this.getCharacteristic(groupedCharacteristics, "shareclass", isUK, "Share Class")}
                            {this.getCharacteristic(groupedCharacteristics, "code", isUK, "Codes")}
                        </div>
                    </div>
                    {(() => {
                        if (safe(() => !isNullOrUndefined(shareClass.disclaimers["shareclass_fundcharacteristics"]) && !shareClass.disclaimers["shareclass_fundcharacteristics"][0].is_deleted, false)) {
                            return (
                                <div className={styles.disclaimer}>
                                    <Disclaimer appParams={appParams} disclaimer={shareClass.disclaimers["shareclass_fundcharacteristics"]}></Disclaimer>
                                </div>
                            );
                        }
                    })()}
                </div> {/*ends the riskrewardContainer */}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/components/PageCharacteristics/index.tsx